import { Component, OnInit, Input } from '@angular/core';
import { InicioService } from '../services/inicio.service';
import { InicioFaces } from '../interfaces/inicioFaces';
import { HttpClient } from '@angular/common/http';
import { ModalService } from '../services/modal.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { AlertsService } from 'angular-alert-module';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import Constants from "../lib/Constants";

@Component({
    selector: 'app-inicio',
    templateUrl: './inicio.component.html',
    styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {

    API_ENDPOINT: string = Constants.BASEURLAPI;
    precioDolar = 0;
    temp = 0;
    humidity = 0;
    pressure = 0;
    name = "";
    submitted = false;
    public now: Date = new Date();
    date;
    inicioModel: InicioFaces[];
    portadaModal: InicioFaces[];
    enlacesModal: InicioFaces[];
    enlacesEModal: InicioFaces[];
    publicafrom: FormGroup;
    publicaModel: InicioFaces[];

    crear: any = {
        contenido: ""
    };

    insert: any = {
        name: "",
        identificacion: "",
        celular: "",
        correo: "",

    };

    registroform = new FormGroup({
        firstName: new FormControl()
    });

    pdfSrc= this.API_ENDPOINT +"/" + "RIT.pdf";



    municipioControl = new FormControl();
    vacunacionControl = new FormControl();
    vacunaControl = new FormControl();
    vacunaDosisControl = new FormControl();

    options: any[] = [{municipio: "POPAYAN"}];
    optionsVacunacion: string[] = ['Si', 'No'];
    optionsVacuna: string[] = ['Astrazeneca', 'Janssen', 'Pfizer', 'Sinovac', 'Moderna'];
    optionsVacunaDosis: string[] = ['1', '2'];


    filteredOptions: Observable<string[]>;
    filteredOptionsVacunacion: Observable<string[]>;
    filteredOptionsVacuna: Observable<string[]>;
    filteredOptionsVacunaDosis: Observable<string[]>;



    //disableSelect = new FormControl(false);


    envioRegistroUsuario: any = {};



    empresas =
        [
            {
                url: 'clicafe.png',
                active: 'active',

            },
            {
                url: 'cosmitet.png',
                active: '',
            },
            {
                url: 'duarquint.png',
                active: '',
            },
            {
                url: 'dumian.png',
                active: '',
            },
            {
                url: 'santaana.png',
                active: '',
            },
            {
                url: 'sofiapa.png',
                active: '',
            },

        ];

    urlVideo: any = 'assets/images/farmacias/COVID2.mp4';

    constructor(private inicioService: InicioService, private httpClient: HttpClient, private modalService: ModalService, private formBuilder: FormBuilder, private alerts: AlertsService) {
        setInterval(() => {
            this.date = new Date();
        }, 1);


    }

    listarExtenciones2() {
        this.inicioService.listarExtenciones().subscribe((data: any) => {
            this.inicioModel = data.obj.areas;

            console.log("this.inicioModel", this.inicioModel);
           
            return;
        },
            (error) => {
                alert('Ocurrio un Error');
                console.log("imprimir", error);
            });
    }


    listarPublica() {
        this.inicioService.mostrarPublica().subscribe((data: any) => {
            
            this.publicaModel = data.obj;
            console.log("qeu trae",data.obj);
            return;
            
            
        },
            (error) => {
                alert('Ocurrio un Error');
                console.log("imprimir", error);
            });
    }


    /*obtenerMunicipios(){
        this.inicioService.obtenerMunicipios().subscribe((data: any) => {
            //this.publicaModel = data.obj
            console.log("Resultado a guardar de listarPublica = ",data)
            this.options = data.obj;
            return;
        },
            (error) => {
                alert('Ocurrio un Error');
                console.log("error de obtenerMunicipios", error);
            });        
    }*/


    goToLink(pdf: string) {
        let url = this.API_ENDPOINT + "/" + pdf;

        window.open(url, "_blank");
    }


    listarEnlaces() {
        this.inicioService.mostrarEnlacesLocales().subscribe((data: any) => {
            this.enlacesModal = data.obj.enlaces;

            console.log("chango", this.enlacesModal);
            return;
        },
            (error) => {
                alert('Ocurrio un Error');
                console.log("imprimir", error);
            });
    }

    
    listarEnlacesExternos() {
        this.inicioService.mostrarEnlacesExternos().subscribe((data: any) => {
            this.enlacesEModal = data.obj.enlaces;
            console.log("pero mira toreto",this.enlacesEModal)

            return;
        },
            (error) => {
                alert('Ocurrio un Error');
                console.log("imprimir", error);
            });
    }

    /* onPublicar() {
    this.inicioService.almacenPublicidad(this.crear).subscribe((data) => {
    },
    (error) => {
    alert('Ocurrio un Error');
    console.log("imprimir", error);
    });

    }*/

    onPublicar() {
        this.submitted = true;

        // stop the process here if form is invalid
        if (this.publicafrom.valid) {
            this.inicioService.almacenPublicidad(this.crear).subscribe((data) => {
                this.alerts.setMessage('PUBLICACIÒN ENTREGADA,Tu publicaciòn esta a la espera de aprobaciòn', 'success');
                this.closeModal('custom-modal-1');
                this.clear();
            });

        } else {
            return;
        }

    }




    //----------------------------------------------------------------------------------------


   /* onRegistrarme(e) {
        //e.preventDefault();
        console.log("información del formulario es: insert = ", this.insert);
        console.log(" vacunacion = ", this.vacunacionControl.value);
        console.log("municipioControl = ", this.municipioControl.value);
        console.log("vacunacionControl = ", this.vacunacionControl.value);
        const municipioSeleccionado = this.options.filter(item => { return item.municipio == this.municipioControl.value })[0];
        console.log("el objeto municipio = ", municipioSeleccionado);

        const validarRegistroFiesta = this.validarRegistroFiesta(municipioSeleccionado);
        if(!validarRegistroFiesta) return false;

        console.log("Detuvo la ejecución -----------------------------------------------")
        this.envioRegistroUsuario = {
            doc_id : this.insert.identificacion,
            nombre_completo : this.insert.name,
            correo_electronico : this.insert.correo,
            celular : this.insert.celular,
            esquema_vacuna : this.vacunacionControl.value,
            tipo_pais_id : municipioSeleccionado.tipo_pais_id, //'50',
            tipo_dpto_id : municipioSeleccionado.tipo_dpto_id, //'51',
            tipo_mpio_id : municipioSeleccionado.tipo_mpio_id, //'1',//this.municipioControl.value,
            nombre_vacuna : this.vacunaControl.value,
            numero_dosis : this.vacunaDosisControl.value
        }

        console.log("info a enviar al controlador ============ ", this.envioRegistroUsuario);

        this.inicioService.reservasFiestaAnual(this.envioRegistroUsuario).subscribe((data : any) => {
            //console.log("DATA DE RESPUESTA DE this.inicioService.reservasFiestaAnual = ",data.status," registró a ",data.obj[0].nombre_completo);
            if(data.status == 200){
                alert("Te has registrado exitosamente " + data.obj[0].nombre_completo);
            }else{
                alert("No se ha podido realizar el registro. " + data.obj.err.detail);
                console.log("data---------------------------- ", data)
            }
            this.alerts.setMessage('Creación Exitosa??', 'success??');
        });


        //this.submitted = true;

        // stop the process here if form is invalid
        /*if (this.registroform.valid) {
            this.inicioService.registroPersonas(this.insert).subscribe((data) => {
            this.alerts.setMessage('REGISTRO EXITOSO,Vacunate y disfruta la fiesta','success');
            this.closeModal('custom-modal-1');
            this.clear();
            });
        }else{
            return;
        }

    }*/

    /*validarRegistroFiesta(municipioSeleccionado){
        if(Object.values(this.insert).filter(item=>item == "").length == 0
            && this.vacunacionControl.value != null
            && this.municipioControl.value != null
            && this.vacunaControl.value != null
            && this.vacunaDosisControl.value
            )
        {
            if(municipioSeleccionado == undefined){
                alert("Debe seleccionar alguno de los municipios del listado")
                return false;
            }
            //llenó todos los campos
            if(this.vacunacionControl.value == "Si"){
                //sigue el bloque de cod
                return true;
            }else{
                alert("Si no está vacunado no irá a la fiesta!!")
                return false
            }
        }else{
            alert("Debe llenar todos los campos o no irá a la fiesta!!")
            return false
        }
        /*console.log("this.insert desde la validación ",Object.values(this.insert).filter(item=>item == "").length);
        console.log("VALIDACION this.vacunacionControl.value = ",this.vacunacionControl.value);
        console.log("VALIDACION this.municipioControl.value = ",this.municipioControl.value);
        console.log("VALIDACION this.vacunaControl.value = ",this.vacunaControl.value);
        console.log("VALIDACION this.vacunaDosisControl.value = ",this.vacunaDosisControl.value);
    }*/
















    clear() {
        this.crear = {};
    }

    tmrColombia() {
        this.inicioService.tmrColombiaService().subscribe((data: any) => {
            let dolar = data.obj.dolar.value;
            this.precioDolar = parseInt(dolar);

            this.temp = data.obj.main.temp;
            this.humidity = data.obj.main.humidity;
            this.pressure = data.obj.main.pressure;
            this.name = data.obj.name;
        },
            (error) => {
                alert('Ocurrio un Error');
                console.log("imprimir", error);
            });
    }

    validarcaracteres() {
        if (this.crear.contenido.length >= 250) {
            return false;

        }
    }

    openModal(id: string) {
        this.modalService.open(id);
    }

    closeModal(id: string) {
        this.modalService.close(id);
    }


   /* private _filter(value: string): any[] {
        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.municipio.toLowerCase().includes(filterValue));
    }

    private _filterVacunacion(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.optionsVacunacion.filter(option => option.toLowerCase().includes(filterValue));
    }

    private _filterVacuna(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.optionsVacuna.filter(option => option.toLowerCase().includes(filterValue));
    }

    private _filterVacunaDosis(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.optionsVacunaDosis.filter(option => option.toLowerCase().includes(filterValue));
    }*/

    ngOnInit() {


      /*this.filteredOptions = this.municipioControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value)),
        );

        this.filteredOptionsVacunacion = this.vacunacionControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filterVacunacion(value)),
        );

        this.filteredOptionsVacuna = this.vacunaControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filterVacuna(value)),
        );

        this.filteredOptionsVacunaDosis = this.vacunaDosisControl.valueChanges.pipe(
            startWith(''),
            map(value => this._filterVacunaDosis(value)),
        );*/

        this.listarPublica();

        /*this.obtenerMunicipios();*/

        this.tmrColombia();
        this.listarEnlaces();
        this.listarExtenciones2();
        this.listarEnlacesExternos();
        this.publicafrom = this.formBuilder.group({
            titulo: ['', Validators.required],
            contenido: ['', Validators.required],
            sede: ['', Validators.required],
            publicador: ['', Validators.required],
        });

    }


}
